import React from "react";
import { connect } from "react-redux";
import { Link } from "gatsby";

import isBrowser from "../utils/isBrowser";

const User = ({ me }) => (
        me && me.login
        ?   <Link
                to="/account"
                css={{
                    padding: 15,
                    fontSize: ".9em",
                    fontWeight: 500,
                }}
            >
                <div css={{
                    color: "lightgrey",
                }}>
                    { me.name || me.login }
                </div>
            </Link>
        :   <Link
                to={ isBrowser() ? "/authorize?path=" + window.location.pathname : "" }
                css={{
                    padding: 15,
                    fontSize: ".8em",
                    textTransform: "uppercase",
                }}
            >
                Login
            </Link>
);

export default connect(
    state => ({ me: state.global.me }),
)(User);
